import React from 'react';
import RtcPlayer from './RtcPlayer';
import './player.scss';

interface Props {
  videoUrl: string;
  direction?: string | React.ReactNode;
  videoId: 0 | 1 | 2 | 3 | 500 | 501 | 502 | 503 | 6; // 前主/右主/后主/左主/前备/右备/后备/左备/红绿灯
  vehicleName?: string;
  warning?: boolean;
  takeOverBySelf?: boolean;
  needSendData?: boolean;
  userName?: string;
  showOpenBtn?: boolean;
  showVideoId: 0 | 1 | 2 | 3 | 500 | 501 | 502 | 503 | 6; // 前主/右主/后主/左主/前备/右备/后备/左备/红绿灯
  getVideoBitRateInfo?: AnyFunc;
  openVideo?: AnyFunc;
  onFrameUpdate?: (timestamp: number) => void;
}

const VideoPlayer = (props: Props) => {
  return (
    <div className="video-box">
      {props.warning && <div className="warning-border"></div>}
      {props.videoUrl && (
        <RtcPlayer
          videoUrl={props.videoUrl}
          onFrameUpdate={props.onFrameUpdate}
          needSendData={props.needSendData}
          userName={props.userName}
          vehicleName={props.vehicleName}
          videoId={props.videoId}
          getVideoBitRateInfo={props.getVideoBitRateInfo}
          showVideoId={props.showVideoId}
        />
      )}
      {props.direction &&
        (typeof props.direction === 'string' ? (
          <span className="direction">{props.direction}</span>
        ) : (
          <>{props.direction}</>
        ))}

      {props.showOpenBtn && (
        <div
          className="open-video-btn"
          onClick={() => props.openVideo && props.openVideo()}
        >
          <img
            src={require('@/assets/images/singleVehicle/camera.png')}
            className="camera"
          ></img>
          <div className="open-tip">
            {props.takeOverBySelf ? '点击开启视频' : '视频已关闭'}
          </div>
        </div>
      )}
    </div>
  );
};
export default React.memo(VideoPlayer);
